import {useContext, useState} from 'react';
import {connect} from 'react-redux';

import _ from 'topmeteo/utils/i18n';

import LightBox from 'topmeteo/general/components/LightBox';
import {LengthContext} from 'topmeteo/flight-planning/components/Drawing';

import Tab from './Tab';
import DownloadTab from './DownloadTab';
import ExportTab from './ExportTab';
import WeGlideTab from './WeGlideTab';

const Tabs = [
    {id: 'download', label: _('Download'), Content: DownloadTab},
    {id: 'export', label: _('LX Export'), Content: ExportTab},
    {id: 'weglide', label: _('WeGlide'), Content: WeGlideTab},
];

const renderTab = (Element, {active, ...props}, {id, label}) => (
    <Element {...props} id={id} key={id} label={label} active={id === active} />
);

const ExportLightBox = ({waypoints, offset, onClose, ...props}) => {
    const [active, setActive] = useState('download');
    const {length} = useContext(LengthContext);

    return (
        <LightBox className="export-light-box" {...props} onClose={onClose} hint>
            <ul className="tab-list">
                {Tabs.map(tab => renderTab(Tab, {active, setActive}, tab))}
            </ul>
            <div className="tab-content">
                {Tabs.map(({Content, ...tab}) => renderTab(Content, {active, onClose, waypoints, length, offset}, tab))}
            </div>
        </LightBox>
    );
};

const mapStateToProps = ({offset}) => ({offset});

export default connect(mapStateToProps)(ExportLightBox);
